module.exports = __webpack_public_path__ + "img/0bf81d0.jpg";